<!-- Invoice Modal  -->
<p-dialog [visible]="true" (onHide)="closePopup()" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '820px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div class="px-4 py-3 flex align-items-center justify-content-between border-bottom-1 border-300">
          <h2 class="mb-0 text-sm" *ngIf="pdfData.type === getPdfType.Invoice || pdfData.type.toString() === getPdfType[getPdfType.Invoice]">
              {{'INVOICE.INVOICE_TTTLE' | translate}}
              <strong>{{ pdfData.numberPrefix }}</strong>
          </h2>
          <h2 class="mb-0 text-sm" *ngIf="pdfData.type === getPdfType.Payment || pdfData.type.toString() === getPdfType[getPdfType.Payment]">
              {{'PAYMENT.PAYMENTS_TTTLE' | translate}}
              <strong>{{ pdfData.numberPrefix }}</strong>
          </h2>
          <h2 class="mb-0 text-sm" *ngIf="pdfData.type === getPdfType.SalesReturn || pdfData.type.toString() === getPdfType[getPdfType.SalesReturn]">
              {{'SALES_RETURN.SALES_TTTLE' | translate}}
              <strong>{{ pdfData.numberPrefix }}</strong>
          </h2>
          <h2 class="mb-0 text-sm" *ngIf="pdfData.type === getPdfType.Refund || pdfData.type.toString() === getPdfType[getPdfType.Refund]">
            {{'REFUND.REFUND' | translate}}
            <strong>{{ pdfData.numberPrefix }}</strong>
        </h2>

          <div class="flex align-items-center justify-content-between">
              <div class="flex align-items-center mr-3">
                  <span class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1" (click)="printPDF()">
                      <i class="fa fa-print"></i>
                  </span>
                  <span class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1" (click)="SendPDF('Email')">
                      <i class=" fa fa-envelope font-light"></i>
                  </span>
                  <span class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1" (click)="SendPDF('WhatsApp')">
                      <i class="fab fa-whatsapp"></i>
                  </span>
                  <span class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1" (click)="downloadPDF()">
                      <i class="fa fa-download"></i>
                  </span>
                  <span
                      class="border-2 border-400 border-round p-1 text-600 w-2rem h-2rem flex align-items-center justify-content-center cursor-pointer mr-1"
                      (click)="moreInfo.toggle($event)"
                      *ngIf="pdfData.status && pdfData.status !=='void'"
                  >
                      <i class="fa fa-ellipsis-v"></i>
                  </span>

                  <p-popover #moreInfo styleClass="overflow-hidden -ml-8 text-sm w-11rem">
                      <ng-template #content>
                          <ul class="list-none -m-4 px-0 py-1 text-xs text-600">
                              <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" (click)="showVoid = true"><i class="fa fa-ban text-500 mr-2"> </i>{{'ADMIN.COMMON.VOID' | translate}}</li>
                          </ul>
                      </ng-template>
                  </p-popover>
              </div>
              <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup()"></div>
          </div>
      </div>
      <!-- Header -->

      <!-- Content -->
      <div class="surface-100 p-3 relative h-30rem">
            <div *ngIf="showSpinner | async" class="absolute left-0 top-0 z-5 flex align-items-center surface-0 justify-content-center w-full h-full">
              <p-progressSpinner></p-progressSpinner>
            </div>
          <pdf-viewer class="static w-full" *ngIf="!loader" [src]="pdfSrc.value" [render-text]="true" [original-size]="true"></pdf-viewer>
      </div>
      <!-- Content -->
  </ng-template>
</p-dialog>
<!-- Invoice Modal -->

<!-- Void  Modal -->
<p-dialog [(visible)]="showVoid" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '630px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">
      <!-- Content -->
      <form [formGroup]="voidForm">
          <div class="relative text-center p-4">
              <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer" (click)="closeVoidPopup()"></div>

              <img width="160" class="block mx-auto" src="/assets/img/void-invoice-img.svg" alt="Image" />

              <h4 class="text-base md:text-lg my-3 font-bold" *ngIf="pdfData.type === getPdfType.SalesReturn || pdfData.type.toString() === getPdfType[getPdfType.SalesReturn]">
                  {{'SALES_RETURN.SALES_DEL_CONFI'| translate}} <br />
                  {{pdfData.numberPrefix }} ?
              </h4>
              <p class="text-600 md:w-26rem mx-auto mb-0" *ngIf="pdfData.type === getPdfType.SalesReturn || pdfData.type.toString() === getPdfType[getPdfType.SalesReturn]">{{'SALES_RETURN.SALES_RETURN_DEL_INFO'| translate}}</p>
              <h4 class="text-base md:text-lg my-3 font-bold" *ngIf="pdfData.type === getPdfType.Invoice || pdfData.type.toString() === getPdfType[getPdfType.Invoice]">
                  {{'INVOICE.INVOICE_DEL_CONFI'| translate}} <br />
                  {{pdfData.numberPrefix }} ?
              </h4>
              <p class="text-600 md:w-26rem mx-auto mb-0" *ngIf="pdfData.type === getPdfType.Invoice || pdfData.type.toString() === getPdfType[getPdfType.Invoice]">{{'INVOICE.INVOICE_DEL_INFO'| translate}}</p>
              <h4 class="text-base md:text-lg my-3 font-bold" *ngIf="pdfData.type === getPdfType.Payment || pdfData.type.toString() === getPdfType[getPdfType.Payment]">
                  {{'PAYMENT.PAYMENT_DEL_CONFI'| translate}} <br />
                  {{pdfData.numberPrefix }} ?
              </h4>
              <p class="text-600 md:w-26rem mx-auto mb-0" *ngIf="pdfData.type === getPdfType.Payment || pdfData.type.toString() === getPdfType[getPdfType.Payment]">{{'PAYMENT.PAYMENT_DEL_INFO'| translate}}</p>
          </div>
          <!-- Content -->

          <!-- Content -->
          <div class="surface-100 p-4">
              <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'INVOICE.REASON'| translate}}</label>
              <textarea pInputTextarea formControlName="void_reason" class="text-sm w-full h-5rem"></textarea>
              <app-error-msg *ngIf="VoidReasonFormControl.touched && VoidReasonFormControl.invalid" [errors]="VoidReasonFormControl.errors" [fieldLabel]="'SALES_RETURN.MSG.REASON_REQUIRED' | translate"> </app-error-msg>
          </div>
          <!-- Content -->

          <!-- Modal Footer -->
          <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
              <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" class="p-button-primary p-button-text text-sm" (click)="closeVoidPopup()"></button>
              <button pButton pRipple type="button" [label]="'common.BUTTONS.BTN_VOID' | translate" class="p-button-danger text-sm" [loading]="btnLoading" (click)="voidData(voidForm)"></button>
          </div>
          <!-- Modal Footer -->
      </form>
  </ng-template>
</p-dialog>
<!-- Void  Modal -->
